"use client";

import { WalletSectionTMA } from "./WalletSection.tma";
import { WalletSectionWeb } from "./WalletSection.web";
import { ConditionalRender } from "@/components/shared/ConditionalRender";

interface WalletSectionProps {
  className?: string;
}

export const WalletSection = ({ className }: WalletSectionProps = {}) => {
  return (
    <ConditionalRender tmaComponent={<WalletSectionTMA className={className} />} webComponent={<WalletSectionWeb />} />
  );
};
